(function () {
    function getVariantIdFromUrl() {
        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
    }

    function updateStockIndicator() {
        var variantId = getVariantIdFromUrl();
        var indicators = document.querySelectorAll('#stock-indicator-wrapper .stock-indicator');

        indicators.forEach(function (indicator, idx) {
            var id = indicator.getAttribute('data-variant-id');
            var fill = indicator.querySelector('.stock-fill');

            // Por defecto, barra en 0% y oculta, y se asegura la transición
            if (fill) {
                fill.style.transition = 'width 0.7s cubic-bezier(0.4, 0, 0.2, 1)'; // animación suave
                fill.style.width = '0%';
                fill.style.background = '';
                fill.style.display = 'none';
            }

            if ((variantId && id == variantId) || (!variantId && idx === 0)) {
                indicator.style.display = '';

                // Tomar el texto de stock directamente (más fiable)
                var stockText = indicator.querySelector('.stock-text')?.innerText || '';
                var stock = parseInt(stockText.replace(/\D/g, ''), 10); // Extraer número

                if (isNaN(stock)) {
                    stock = 0;
                }

                if (fill) {
                    if (stock <= 0) {
                        fill.style.width = '0%';
                        fill.style.backgroundColor = '#ccc';
                        fill.style.display = 'none';
                    } else {
                        // Para forzar la animación incluso si el mismo fill se reutiliza
                        fill.style.display = '';
                        setTimeout(function () {
                            if (stock <= 8) {
                                fill.style.width = '20%';
                                fill.style.background = 'linear-gradient(47.28deg, #B75858 0%, #9B3B3B 62.52%, #7F2020 96.18%)';
                            } else if (stock <= 49) {
                                fill.style.width = '40%';
                                fill.style.background = 'linear-gradient(47.28deg, #B77F58 0%, #9B613B 62.52%, #804620 96.18%)';
                            } else {
                                fill.style.width = '100%';
                                fill.style.background = 'linear-gradient(47.28deg, #7FB758 0%, #619B3B 62.52%, #467F20 96.18%)';
                            }
                        }, 30); // pequeño delay para asegurar la transición
                    }
                }
            } else {
                indicator.style.display = 'none';
            }
        });
    }

    window.addEventListener('popstate', updateStockIndicator);
    window.addEventListener('DOMContentLoaded', updateStockIndicator);
    document.addEventListener('variant:change', function () {
        setTimeout(updateStockIndicator, 150);
    });
    document.addEventListener('shopify:section:load', updateStockIndicator);
})();